// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import {Link} from 'react-router-dom';
  import { withRouter } from 'react-router';
  
  
  class CancelBooking extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        subscription_id: props.match.params.id,
        data_uploaded: false,
        data_error: false,
        mobile_no: '',
        court_name: '',
        start_date: '',
        start_time: '',
        results: {
          court: '',
          start_time: '',
          date: '',
        },
        court_bookings: [],
        loading:false,
      };
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
  
    componentDidMount() {
        console.log('book')
      this.getDetails(this.state.subscription_id)
    }
  
    postCancelBooking(data, props) {
      console.log(data);
      this.setState({loading:true})
      const url = `${getLocationOrigin()}/court_booking/cancel_bulk_booking/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({'subscription_id': data,
                                            });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then((response) => {                  
          alert(response.message);
          this.setState({loading:false})
          })
        .catch((error) => {
          console.log(error);
          alert(error.message);
          this.setState({loading:false})
        });
    }
    
    getDetails(data){
        console.log('get details')
        const url = `${getLocationOrigin()}/court_booking/get_bulk_booking/?subscription_id=${data}`;
        const options = {...defaultOptions};

        console.log('Going to fetch')
        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => this.setState({ court_bookings: data.court_bookings}))
        .catch(error => error);
    }

    handleSubmit(event) {
      event.preventDefault();
      console.log('Submit');
      this.postCancelBooking(this.state.subscription_id, this.props);
      console.log('post');
      console.log(this.state);
    }
  
    render() {
      console.log('render')
      console.log(this.state.results)
      return(
        <div style={styles.container}>
          <div className="row col-md-8 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12">
              <h3 style={{textAlign:'center'}}>Cancel Court Booking</h3>
            </div>
            <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
            {this.state.loading === true ?
              <div style={{height:100}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}>loading...</div>
              </div>
            :
            <div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-12">
                <div style={{textAlign:'center'}}>Are you sure you want to cancel booking??</div>
              </div>
              </div>
              <div style={styles.button_submit} className="col-md-12">
                <input className="btn btn-lg" type="submit" value="Cancel Booking" style={{backgroundColor:'#302C35',
                  color:'#ffffff'}}/>
              </div>
            </div>
            }
            </form>
          </div>
        </div>
      );
    }
  }
  
  export default CancelBooking;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/cancelBooking/index.js